import { ReactElement } from 'react';
import styles from './JobStatusCellRenderer.module.scss';
import { Typography } from '@getgo/chameleon-web-react-wrapper/register';
import StatusIcon from './status-icon/StatusIcon';
import { JobStatusCellRendererProps } from '../../../types/frontend/cell-renderers/JobStatusCellRenderer.types';
import { useJobStatusCellRenderer } from './hooks/UseJobStatusCellRenderer';

export function JobStatusCellRenderer({
  jobRunStatistics,
  jobStatus,
  isOsUpdate,
  status
}: JobStatusCellRendererProps): ReactElement {
  const { statusText, statisticsText } = useJobStatusCellRenderer({ jobRunStatistics, jobStatus, isOsUpdate, status });

  return (
    <div className={styles.container}>
      <StatusIcon jobStatus={jobStatus} />
      <div className={styles.textContainer}>
        <Typography variant="body-small" className={styles.statistics}>
          {statusText}
        </Typography>
        {jobRunStatistics && (
          <Typography variant="caption-small" color="type-color-secondary" className={styles.statistics}>
            {statisticsText}
          </Typography>
        )}
      </div>
    </div>
  );
}
